var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8751 5.97474C26.8934 6.23512 26.8934 6.4955 26.8934 6.75829C26.8934 14.7654 20.7152 24 9.41826 24V23.9952C6.08109 24 2.81325 23.0569 0.00390625 21.2786C0.489157 21.3362 0.97684 21.365 1.46574 21.3662C4.2313 21.3686 6.91782 20.453 9.09354 18.7671C6.4654 18.7179 4.16077 17.0272 3.35566 14.559C4.2763 14.7342 5.22491 14.6982 6.12853 14.4546C3.26323 13.8834 1.20183 11.3996 1.20183 8.51498C1.20183 8.48858 1.20183 8.46338 1.20183 8.43818C2.05558 8.90735 3.01149 9.16774 3.98929 9.19653C1.29061 7.41705 0.458753 3.87487 2.08842 1.10545C5.20667 4.89121 9.80743 7.19266 14.7463 7.43625C14.2513 5.33158 14.9275 3.12612 16.5231 1.64661C18.9968 -0.647644 22.8873 -0.530052 25.2126 1.90939C26.5881 1.64181 27.9064 1.14384 29.1129 0.438287C28.6544 1.841 27.6948 3.03252 26.413 3.78968C27.6304 3.64808 28.8198 3.3265 29.9399 2.83574C29.1153 4.05486 28.0767 5.11679 26.8751 5.97474Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f59485043bf3cfe55f809d6717c3cd5e.svg";
export { ForwardRef as ReactComponent };